import { Col, Panel } from 'react-bootstrap';

interface IProps { }

const Sources = (props: IProps) => {
    return (
        <div className="row row-margined">
            <Col xs={12}>
                <Panel default>
                    <div className="panel-heading">Sources</div>
                    <div className="panel-body" style={{ border: 'none' }}>
                        <ol style={{ paddingLeft: '20px' }}>
                            <li>List of HLA eplets from HLA Epitope Registry (<a href="https://www.epregistry.com.br/" target="_blank" rel="noopener noreferrer">https://www.epregistry.com.br/</a>)</li>
                            <li>Protein Alignment from IPD-IMGT/HLA Database (<a href="https://www.ebi.ac.uk/ipd/imgt/hla/alleles/dictionary/" target="_blank" rel="noopener noreferrer">https://www.ebi.ac.uk/ipd/imgt/hla/alleles/dictionary/</a>)</li>
                            <li>Risk stratification based on Wiebe C, Kosmoliaptsis V, Pochinco D, et al. HLA-DR/DQ molecular mismatch: A prognostic biomarker for primary alloimmunity. Am J Transplant. 2019 Jun;19(6):1708-1719. doi: 10.1111/ajt.15177. Epub 2018 Dec 15. PMID: 30414349; PMCID: PMC6563434.</li>
                            <li>Also see the risk stratification validation study in the U.S. by Davis S, Wiebe C, Campbell K, et al. Adequate tacrolimus exposure modulates the impact of HLA class II molecular mismatch: a validation study in an American cohort. Am J Transplant. 2020 Sep 4. doi: 10.1111/ajt.16290. Epub ahead of print. PMID: 32888256.</li>
                            <li>Tacrolimus Level Risk based on Wiebe C, Rush DN, Nevins TE, et al. Class II Eplet Mismatch Modulates Tacrolimus Trough Levels Required to Prevent Donor-Specific Antibody Development. J Am Soc Nephrol. 2017 Nov;28(11):3353-3362. doi: 10.1681/ASN.2017030287. Epub 2017 Jul 20. PMID: 28729289; PMCID: PMC5661295.</li>
                        </ol>
                    </div>
                </Panel>
            </Col>
        </div>
    );
}

export default Sources;
